import { UseQueryResult, useQuery } from '@tanstack/react-query';
import { API } from 'api';
import { OrganizationPricing } from 'features/organizations/organizations.types';

export type UseOrganizationPricing = Omit<
  UseQueryResult<OrganizationPricing, Error>,
  'data'
> & {
  pricing?: OrganizationPricing;
};

const fetchOrganizationPricing = async (): Promise<OrganizationPricing> => {
  const result = await API.get<OrganizationPricing>('organization/pricing/');
  return result.data;
};

export const useOrganizationPricing = (): UseOrganizationPricing => {
  const { data, ...results } = useQuery<OrganizationPricing>({
    queryKey: ['organizationPricing'],
    queryFn: () => fetchOrganizationPricing(),
    staleTime: 1000 * 60 * 60, // 1 hour
  });

  return {
    ...results,
    pricing: data,
  };
};
